"use client";

import { ToastProvider } from "@repo/design-system";

export default function ClientToastProvider() {
  return <ToastProvider />;
}
